<style>
.users {
    max-width: 1540px;
    width: 100%;
    position: relative;
}

.users_top li {
    padding: 20px;
}

.users .users_top {
    display: flex;
}

.users .users_top li {
    max-width: 256px;
    width: 100%;
    padding: 20px 20px 15px;
    border-bottom: 5px solid;
    background: #FFF;
}

.users .users_top .total_ftd {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.users .users_top .total_ftd .total_ftd_right {
    display: flex;
    align-items: center;
}

.users .users_top .total_ftd .total_ftd_left span {
    font-size: 16px;
}

.users .users_top .total_ftd .total_ftd_right span {
    font-size: 14px;
    color: #1DD1A1;
}

.users .users_top .total_ftd .total_ftd_right img {
    width: 24px;
    height: 24px;
}

.users .users_top li h3 {
    font-size: 30px;
    color: #000;
    line-height: 1.367;
    padding-bottom: 20px;
}

.users .users_top li p {
    font-size: 14px;
    color: #898787;
}

.users .users_top li h4 {
    font-size: 16px;
    color: #000;
}

.users .users_top .total {
    border-bottom: 5px solid #006bff;
}

.users .users_top .Total_Live {
    border-bottom: 5px solid #006bff;
}

.users .users_top .Total_Demo {
    border-bottom: 5px solid #006bff;
}

.users .users_top .Total_Partner {
    border-bottom: 5px solid #006bff;
}

.users .users_top .Total_App {
    border-bottom: 5px solid #006bff;
}

.users .users_top .FTD_live {
    border-bottom: 5px solid #006bff;
}
.trend_load {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #ffffff;
}
.el-icon-loading{font-size: 50px;}
</style>
<template>
    <div class="users">
        <ul class="users_top">
            <li class="total">
                <div class="total_ftd">
                    <div class="total_ftd_left"><span>Total FTD</span></div>
                    <div class="total_ftd_right" v-if="digital.totalFirstDepositGrowthRate >= 0"><span>{{
                        digital.totalFirstDepositGrowthRate }}</span>
                        <img src="../assets/img/total_ftd_rise.webp" alt="">
                        </div>
                    <div class="total_ftd_right" v-else><span style="color: red;">{{ digital.totalFirstDepositGrowthRate
                            }}</span>
                            <img src="../assets/img/total_ftd_decline.webp" alt="">
                            </div>
                </div>
                <h3>{{ digital.totalFirstDeposit }}</h3>
                <p>Previous {{ users.timeUnit }}</p>
                <h4>{{ prevData.totalFirstDeposit }}</h4>
            </li>
            <li class="Total_Live">
                <div class="total_ftd">
                    <div class="total_ftd_left"><span>Total Live</span></div>
                    <div class="total_ftd_right" v-if="digital.totalLiveGrowthRate >= 0"><span>{{
                        digital.totalLiveGrowthRate }}</span>
                        <img src="../assets/img/total_ftd_rise.webp" alt="">
                    </div>
                    <div class="total_ftd_right" v-else><span style="color: red;">{{ digital.totalLiveGrowthRate
                            }}</span>
                            <img src="../assets/img/total_ftd_decline.webp" alt="">
                        </div>
                </div>
                <h3>{{ digital.totalLive }}</h3>
                <p>Previous {{ users.timeUnit }}</p>
                <h4>{{ prevData.totalLive }}</h4>
            </li>
            <li class="Total_Demo">
                <div class="total_ftd">
                    <div class="total_ftd_left"><span>Total Demo</span></div>
                    <div class="total_ftd_right" v-if="digital.totalDemoGrowthRate >= 0">
                        <span>{{ digital.totalDemoGrowthRate }}</span>
                        <img src="../assets/img/total_ftd_rise.webp" alt="">
                    </div>
                    <div class="total_ftd_right" v-else><span style="color: red;">{{ digital.totalDemoGrowthRate
                            }}</span>
                            <img src="../assets/img/total_ftd_decline.webp" alt="">
                        </div>
                </div>
                <h3>{{ digital.totalDemo }}</h3>
                <p>Previous {{ users.timeUnit }}</p>
                <h4>{{ prevData.totalDemo }}</h4>
            </li>
            <li class="Total_Partner">
                <div class="total_ftd">
                    <div class="total_ftd_left"><span>Total Partner</span></div>
                    <div class="total_ftd_right" v-if="digital.totalPartnerGrowthRate >= 0"><span>{{
                        digital.totalPartnerGrowthRate }}</span>
                        <img src="../assets/img/total_ftd_rise.webp" alt="">
                    </div>
                    <div class="total_ftd_right" v-else><span style="color: red;">{{ digital.totalPartnerGrowthRate
                            }}</span>
                            <img src="../assets/img/total_ftd_decline.webp" alt="">
                        </div>
                </div>
                <h3>{{ digital.totalPartner }}</h3>
                <p>Previous {{ users.timeUnit }}</p>
                <h4>{{ prevData.totalPartner }}</h4>
            </li>
            <li class="Total_App">
                <div class="total_ftd">
                    <div class="total_ftd_left"><span>Total App</span></div>
                    <div class="total_ftd_right" v-if="digital.totalAppGrowthRate >= 0"><span>{{
                        digital.totalAppGrowthRate }}</span>
                        <img src="../assets/img/total_ftd_rise.webp" alt="">
                    </div>
                    <div class="total_ftd_right" v-else><span style="color: red;">{{ digital.totalAppGrowthRate
                            }}</span>
                            <img src="../assets/img/total_ftd_decline.webp" alt="">
                        </div>
                </div>
                <h3>{{ digital.totalApp }}</h3>
                <p>Previous {{ users.timeUnit }}</p>
                <h4>{{ prevData.totalApp }}</h4>
            </li>
            <li class="FTD_live">
                <div class="total_ftd">
                    <div class="total_ftd_left"><span>FTD/live</span></div>
                    <div class="total_ftd_right" v-if="digital.newUserConversionGrowthRate >= 0"><span>{{
                        digital.newUserConversionGrowthRate }}</span>
                        <img src="../assets/img/total_ftd_rise.webp" alt="">
                        </div>
                    <div class="total_ftd_right" v-else><span style="color: red;">{{ digital.newUserConversionGrowthRate
                            }}</span>
                            <img src="../assets/img/total_ftd_decline.webp" alt="">
                        </div>
                </div>
                <h3>{{ digital.newUserConversionRate }}</h3>
                <p>Previous {{ users.timeUnit }}</p>
                <h4>{{ prevData.newUserConversionRate }}</h4>
            </li>
        </ul>
        <div class="users_bottom">
            <div id="container" style="height: 600px;width: 1540px;overflow: hidden;"></div>
        </div>
        <div class="trend_load">
            <i class="el-icon-loading"></i>
        </div>
    </div>
</template>
<script>
var echarts = require('echarts')
import $ from 'jquery'
import cookies from 'js-cookie'
export default {
    data () {
        return {
            digital: {},
            prevData: {},
            option: {
                title: {
                    text: ''
                },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: []
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: []
                },
                yAxis: {
                    type: 'value'
                },
                series: [

                ]
            },
            users: {
                lastings: '',
                days: '',
                timeUnit: '',
            },
        }
    },
    watch: {
        users:{
            handler:function(oldval, newval){
                if (JSON.stringify(newval.lastings) != "null" & JSON.stringify(newval.days) != "null" & JSON.stringify(newval.timeUnit) != "null") {
                    this.getDatas()
                }
            },
            deep:true
        }
    },
    mounted () {
        let this_s = this
        setInterval(function () {
            this_s.users.lastings = sessionStorage.getItem("lasting")
            this_s.users.days = sessionStorage.getItem("days")
            this_s.users.timeUnit = sessionStorage.getItem("timeUnit")
        }, 2000)
        var dom = document.getElementById('container')
        var myChart = echarts.init(dom, null, {
            renderer: 'canvas',
            useDirtyRect: false,
        })
        var option = this.option
        if (option && typeof option === 'object') {
            myChart.setOption(option)
        }
        window.addEventListener('resize', myChart.resize)
        setInterval(function () {
            myChart.setOption(option)
        }, 1000)
    },
    
    methods: {
        constructor () {
            this.getDatas = function () {
                // 函数实现
            }
        },
        getDatas () {
            let this_f = this
            $.ajax({
                type: "GET",
                url: "https://google-analytics-test.canglankeji.com/api/marketing/users",
                data: {
                    type: 'users',
                    baseTime: this.users.lastings,
                    value: this.users.days,
                    timeUnit: this.users.timeUnit,
                },
                headers: {
                    Authorization: "Bearer " + cookies.get("token"),
                },
                dataType: 'json',
                success: function (res) {
                    console.log(res)
                    if (res.code == 0) {
                        this_f.digital = res.result.dashboardDTO
                        this_f.prevData = res.result.prevData
                        for (let index = 0; index < res.result.xAxis[0].length; index++) {
                            this_f.option.xAxis.data = (res.result.xAxis[0])
                        }
                        var arrer = []
                        var teeda = []
                        for (let index = 0; index < res.result.yAxis.length; index++) {
                            arrer.push(res.result.yAxis[index].name)
                            teeda.push({
                                name: res.result.yAxis[index].name,
                                type: 'line',
                                data: res.result.yAxis[index].value[0],
                            })
                        }
                        this_f.option.legend.data = arrer
                        this_f.option.series = teeda

                        $(".trend_load").hide()
                    }
                }
            })
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/views/Users.vue